import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name arrayService
     * @memberof app
     *
     * @description
     * Todo
     *
     * @author somarten.btc
     */
    angular.module('app').service('arrayService', arrayService);

    function arrayService() {
        return {
            getElementInArrayWhereKeyEqualsValue:
                getElementInArrayWhereKeyEqualsValue,
            hasElementInArrayWhereKeyEqualsValue:
                hasElementInArrayWhereKeyEqualsValue,
            indexOfElementInArrayWhereKeyEqualsValue:
                indexOfElementInArrayWhereKeyEqualsValue
        };

        /**
         *
         * @param elementFieldName
         * @param array
         * @param keyFieldName
         * @param keyValue
         * @returns {*}
         */
        function getElementInArrayWhereKeyEqualsValue(
            elementFieldName,
            array,
            keyFieldName,
            keyValue
        ) {
            if (angular.isUndefined(array) || array === null) {
                return null;
            }
            for (var i = 0; i < array.length; i++) {
                if (array[i][keyFieldName] === keyValue) {
                    return array[i][elementFieldName];
                }
            }
            return null;
        }

        /**
         *
         * @param array
         * @param keyFieldName
         * @param keyValue
         * @returns {boolean}
         */
        function hasElementInArrayWhereKeyEqualsValue(
            array,
            keyFieldName,
            keyValue
        ) {
            if (angular.isUndefined(array) || array === null) {
                return false;
            }
            for (var i = 0; i < array.length; i++) {
                if (array[i][keyFieldName] === keyValue) {
                    return true;
                }
            }
            return false;
        }

        /**
         *
         * @param array
         * @param keyFieldName
         * @param keyValue
         * @returns {number}
         */
        function indexOfElementInArrayWhereKeyEqualsValue(
            array,
            keyFieldName,
            keyValue
        ) {
            if (angular.isUndefined(array) || array === null) {
                return -1;
            }
            for (var i = 0; i < array.length; i++) {
                if (array[i][keyFieldName] === keyValue) {
                    return i;
                }
            }
            return -1;
        }
    }
})();
